// extracted by mini-css-extract-plugin
module.exports = {"swipe-view":"_1w1bK","swipe-label":"H9_8w","shake":"_2yniD"};